import _mixin from '../_mixin'

export default {
  name: 'SVideoEncourageActivity',
  cnName: '视频激励活动',
  type: 'activity_other',
  preview: 'https://rescdn.ssjj.cn/website/2024/05/17/1f251f33e8d30b965516cb67201f8eda.jpg',
  // 属性相关
  props: {
    defaultBg: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/21/3741729c1293328e98ae185a279aa39d.jpg',
      style: {
        width: '100%',
        height: '6716px'
      }
    },
    kvBg: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/21/e42735a38c66f215ad391a02a40928cb.jpg',
      style: {
        width: '100%',
        height: '900px'
      }
    },
    timeImg: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/21/a4ec1a9aafc4d455055c81ff3e94d92e.png',
      style: {
        width: '341px',
        height: '56px',
        position: 'absolute',
        top: '408px',
        right: '',
        bottom: '',
        left: '782px'
      }
    },
    btnSign: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/21/d7727332796838e69c63bf80ed4b8bf5.png',
      style: {
        width: '404px',
        height: '128px',
        position: 'absolute',
        top: '460px',
        right: '',
        bottom: '',
        left: '800px'
      }
    },
    signLink: 'https://docs.qq.com/form/page/DQ3hod2x6U3RqUHVq#/fill',
    title1: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/21/be5a3c010dee4f31f4da3960f0836d7b.png',
      style: {
        width: '606px',
        height: '201px'
      }
    },
    schedule: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/21/22d861578f73f8b381d889b9e2704a6b.png',
      style: {
        width: '1314px',
        height: '579px'
      }
    },
    title2: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/21/c6a8a27f93a661ee38c4a019740ac721.png',
      style: {
        width: '606px',
        height: '201px',
        position: 'absolute',
        top: '127px',
        right: '',
        bottom: '',
        left: '731px'
      }
    },
    join: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/21/a50a7bf3b26211bdfe707693283bb334.png',
      style: {
        width: '1428px',
        height: '1317px'
      }
    },
    title3: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/21/3276e76f0da5bb3958ab2a0b8c0ae1d9.png',
      style: {
        width: '606px',
        height: '201px'
      }
    },
    awardBg: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/22/261830621c2f107112c44ba8b74c7cbb.png',
      style: {
        width: '1547px',
        height: '970px'
      }
    },
    awardList: [
      {
        img: 'https://rescdn-crash.ssjj.cn/website/2025/05/22/fb41b63ba92107f7da980ddf3a54b2f0.png',
        activeImg: 'https://rescdn-crash.ssjj.cn/website/2025/05/22/561ab8831a1a29f0a3254086a9764cb2.png',
        awardImg: 'https://rescdn-crash.ssjj.cn/website/2025/05/22/3b04e1dc4e34de2d8cad7c9820dcf7a2.png'
      },
      {
        img: 'https://rescdn-crash.ssjj.cn/website/2025/05/22/8d4d4790c3e4cf85e8549c388791488b.png',
        activeImg: 'https://rescdn-crash.ssjj.cn/website/2025/05/22/244f59343922a8700e722518548c2b84.png',
        awardImg: 'https://rescdn-crash.ssjj.cn/website/2025/05/22/a54acebefbf0e66c0b74a072beb069ab.png'
      },
      {
        img: 'https://rescdn-crash.ssjj.cn/website/2025/05/22/d4c404fa281744ff6e7ee74218bfab2e.png',
        activeImg: 'https://rescdn-crash.ssjj.cn/website/2025/05/22/2f6a543f049499b7e7b35b9b5e48d687.png',
        awardImg: 'https://rescdn-crash.ssjj.cn/website/2025/05/22/ea78775f915f718179b6187f196ec610.png'
      }
    ],
    awardTagImg: "146px 68px",
    awardTagImgActive: "146px 77px",
    title4: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/21/6b39a490e2d015cfda221732c8a28575.png',
      style: {
        width: '606px',
        height: '201px'
      }
    },
    highlightsBg: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/22/46cb49dfd6a4d4780a4d5ad87bb9f852.png',
      style: {
        width: '1432px',
        height: '1026px'
      }
    },
    btnPlay: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/22/773497449a48af726104a2301058ed43.png',
      style: {
        width: '116px',
        height: '106px'
      }
    },
    btnSwiperLeft: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/22/52535e9f2afe615b36777be295aa65f9.png',
      style: {
        width: '73px',
        height: '118px'
      }
    },
    btnSwiperRight: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/22/34a83fb6afb16e4f5fa8f83380028d76.png',
      style: {
        width: '73px',
        height: '118px'
      }
    },
    title5: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/21/b7bffc46776682b9d264a1340e2ee63a.png',
      style: {
        width: '606px',
        height: '201px'
      }
    },
    rule: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/22/51430a09507370450c364df6b5c32a18.png',
      style: {
        width: '1379px',
        height: '983px'
      }
    },
    tagBg: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/23/91fbda7ad685cbb959a5d8b681077231.png',
      style: {
        width: '261px',
        height: '771px'
      }
    },
    tagList: [
      {
        img: 'https://rescdn-crash.ssjj.cn/website/2025/05/23/214a1acf2881422d3b729f195a348315.png',
        activeImg: 'https://rescdn-crash.ssjj.cn/website/2025/05/23/023295197a0c62120f11eccb67226404.png'
      },
      {
        img: 'https://rescdn-crash.ssjj.cn/website/2025/05/23/71df6b89649f9997e935a57d1e3cbd3f.png',
        activeImg: 'https://rescdn-crash.ssjj.cn/website/2025/05/23/ab68f1b8f3a8a876b200cdb462973cf0.png'
      },
      {
        img: 'https://rescdn-crash.ssjj.cn/website/2025/05/23/a6f4ae7276b4bb397056506d6c32d6c0.png',
        activeImg: 'https://rescdn-crash.ssjj.cn/website/2025/05/23/4fedc0d6bb91824b9baaced05384a340.png'
      },
      {
        img: 'https://rescdn-crash.ssjj.cn/website/2025/05/23/31d61f79fd29823c967e4ad38e810ba6.png',
        activeImg: 'https://rescdn-crash.ssjj.cn/website/2025/05/23/a9e7c440a61ac9211cce422d8ba6e77b.png'
      },
      {
        img: 'https://rescdn-crash.ssjj.cn/website/2025/05/23/72d8e8c5e8d785373aab38c8fb14266f.png',
        activeImg: 'https://rescdn-crash.ssjj.cn/website/2025/05/23/ab6dde65bc210e8854d4199ef583f6f3.png'
      },
      {
        img: 'https://rescdn-crash.ssjj.cn/website/2025/05/23/fe24964e5e1c45abb32daed40b90ff00.png',
        activeImg: 'https://rescdn-crash.ssjj.cn/website/2025/05/23/3aa89ca932cf08aa51d1ce52c5d3f273.png'
      }
    ],
    websiteImg: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/05/23/ea0ccea4118761543e8d476c9f3f5e59.png',
      style: {
        width: '115px',
        height: '43px',
        position: 'absolute',
        top: '',
        right: '',
        bottom: '40px',
        left: '75px'
      }
    },
    websiteLink: 'https://www.ssjj.cn/'
  },
  propsDesc: [
    {
      target: 'defaultBg',
      label: '背景图',
      formType: 'image'
    },
    {
      target: 'kvBg',
      label: 'kv图',
      formType: 'image'
    },
    {
      target: 'timeImg',
      label: '活动时间图',
      formType: 'image'
    },
    {
      target: 'btnSign',
      label: '立即报名按钮',
      formType: 'image'
    },
    {
      target: 'signLink',
      label: '立即报名跳转链接'
    },
    {
      target: 'title1',
      label: '活动日程标题',
      formType: 'image'
    },
    {
      target: 'schedule',
      label: '活动日程',
      formType: 'image'
    },
    {
      target: 'title2',
      label: '参与方式标题',
      formType: 'image'
    },
    {
      target: 'join',
      label: '参与方式',
      formType: 'image'
    },
    {
      target: 'title3',
      label: '活动奖励标题',
      formType: 'image'
    },
    {
      target: 'awardBg',
      label: '活动奖励背景',
      formType: 'image'
    },
    {
      target: 'awardList',
      label: '活动奖励轮播列表',
      formType: 'list',
      listConfig: [
        {
          title: '默认图',
          target: 'img'
        },
        {
          title: '选中图',
          target: 'activeImg'
        },
        {
          title: '大图',
          target: 'awardImg'
        }
      ]
    },
    {
      target: 'awardTagImg',
      label: '奖励默认tag图大小'
    },
    {
      target: 'awardTagImgActive',
      label: '奖励选中tag图大小'
    },
    {
      target: 'title4',
      label: '精彩稿件标题',
      formType: 'image'
    },
    {
      target: 'highlightsBg',
      label: '精彩稿件背景',
      formType: 'image'
    },
    {
      target: 'btnPlay',
      label: '播放按钮',
      formType: 'image'
    },
    {
      target: 'btnSwiperLeft',
      label: '轮播图左按钮',
      formType: 'image'
    },
    {
      target: 'btnSwiperRight',
      label: '轮播图右按钮',
      formType: 'image'
    },
    {
      target: 'title5',
      label: '活动须知标题',
      formType: 'image'
    },
    {
      target: 'rule',
      label: '活动规则',
      formType: 'image'
    },
    {
      target: 'tagBg',
      label: '背景图',
      formType: 'image'
    },
    {
      target: 'tagList',
      label: '导航列表',
      formType: 'list',
      listConfig: [
        {
          title: '默认图',
          target: 'img'
        },
        {
          title: '选中图',
          target: 'activeImg'
        }
      ]
    },
    {
      target: 'websiteImg',
      label: '官方网站图',
      formType: 'image'
    },
    {
      target: 'websiteLink',
      label: '官方网站跳转链接'
    }
  ],

  // 样式相关
  styles: {
    ..._mixin.styles
  },
  stylesDesc: [
    ..._mixin.stylesDesc
  ],

  // 事件相关
  events: {
    // click: () => {} 无需配置
  },
  eventsList: [
    // eventTpl 无需配置
  ],
  eventsDesc: [
    ..._mixin.eventsDesc
  ],

  methods: [
    ..._mixin.methods
  ],
  children: [
    // {
    //   id: genId() + '_BaseGroup_0',
    //   ...BaseGroup
    // },
    // {
    //   id: genId() + '_BaseGroup_1',
    //   ...BaseGroup
    // }
  ]
}
